import React, { useState } from "react";
import { Form, Container, Button, Row, Col, Badge, Stack} from "react-bootstrap";
import { XCircleFill, PlusCircle } from "react-bootstrap-icons";
import { contractApi } from "../api";
import Swal from "sweetalert2";



const AdaugContract = ({ tema, partizi = [], user }) => {
  const [nrCtr, setNrCtr] = useState("");
  const [ocol, setOcol] = useState("");
  const [tip, setTip] = useState("");
  const [partener, setPartener] = useState("");
  const [proprietar, setProprietar] = useState("Stat");
  const [partiziSelectateIds, setPartiziSelectateIds] = useState([]);

React.useEffect(() => {
  if (user) {
    // Verificăm ambele variante (rol sau role) și facem litere mici
    const rolul = (user.rol || "").toLowerCase();

    if (rolul !== "administrator" && user.ocol) {
      setOcol(user.ocol);
    }
  }
}, [user]);

  
  // 1. Filtrare partizi disponibile pentru ocolul selectat
  const disponibile = partizi.filter((p) => {
    const esteDisponibila =
      p.stare === "disponibil" && !partiziSelectateIds.includes(p.id);

    // Dacă e ADMIN, vede tot ce e selectat în dropdown
    if (user?.rol === "administrator") {
      return esteDisponibila && p.ocol === ocol;
    }

    // Dacă e USER, vede DOAR partizile din ocolul lui,
    // chiar dacă încearcă să schimbe dropdown-ul
    return esteDisponibila && p.ocol === user?.ocol;
  });
  // 2. CALCUL AUTOMAT VOLUM ȘI VALOARE (din datele partizilor)
  const calcule = partiziSelectateIds.reduce(
    (acc, id) => {
      const p = partizi.find((partida) => partida.id === id);
      if (p) {
        acc.volum += parseFloat(p.volBrut || 0);
        acc.valoare += parseFloat(p.valTotal || 0); // Presupunem că field-ul se numește valTotal
      }
      return acc;
    },
    { volum: 0, valoare: 0 },
  );

  const adaugaPartida = (id) =>
    setPartiziSelectateIds([...partiziSelectateIds, id]);
  const eliminaPartida = (id) =>
    setPartiziSelectateIds(partiziSelectateIds.filter((pid) => pid !== id));

  const tratezSubmit = async (evt) => {
    evt.preventDefault();
    if (!nrCtr || !ocol || partiziSelectateIds.length === 0 || !partener || !proprietar) {
      Swal.fire({
        title: "Atenție!",
        text: "Te rog selectează ocolul, partenerul, proprietarul și cel puțin o partidă!",
        icon: "warning",
        confirmButtonText: "Am înțeles",
        timer: 3000,
        timerProgressBar: true,
        confirmButtonColor: "#f8bb86", // O culoare portocalie specifică avertizărilor
        showClass: {
          popup: "animate__animated animate__shakeX", // O animație de "tremurat" pentru a atrage atenția
        },
      });
      return;
    }

   try {
     await contractApi.create({
       nrCtr,
       ocol,
       tip,
       partener,
       proprietar,
       partiziSelectateIds,
       calcule: {
         volum: parseFloat((calcule?.volum || 0).toFixed(2)),
         valoare: parseFloat((calcule?.valoare || 0).toFixed(2)),
       },
     }, user);

     await Swal.fire({
       title: "Succes!",
       text: `Contractul nr. ${nrCtr} a fost salvat cu succes.`,
       icon: "success",
       showCloseButton: true,
       showConfirmButton: false,
       timer: 2000, // Se închide singur după 3 secunde dacă nu apeși nimic
       timerProgressBar: true,
       showClass: {
         popup: "animate__animated animate__fadeInDown", // Necesită Animate.css sau setările default
       },
     });

     // Resetăm formularul
     setPartiziSelectateIds([]);
     setNrCtr("");
     setPartener("");
     setTip("");
   } catch (error) {
     console.error("Eroare la submit:", error);
     Swal.fire({
    title: 'Eroare!',
    text: 'Nu s-a putut salva contractul: ' + error.message,
    icon: 'error',
    timer: 3000,
    timerProgressBar: true,
    confirmButtonText: 'Încearcă din nou',
    confirmButtonColor: '#dc3545'
  });
   }
  };

  return (
    <Container
      className="py-4"
      style={{
        marginTop: "2rem",
        backgroundColor: tema === "dark" ? "#212529" : "#ffffff",
        color: tema === "dark" ? "#f8f9fa" : "#212529",
        borderRadius: "12px",
        border: tema === "dark" ? "1px solid #373b3e" : "1px solid #dee2e6",
      }}
    >
      <h4 className="mb-4">Creare Contract</h4>
     
      <Form onSubmit={tratezSubmit}>
        <Row className="mb-4">
          <Col md={2}>
            <Form.Group>
              <Form.Label className="fw-bold">Nr. ctr.</Form.Label>
              <Form.Control
                type="text"
                value={nrCtr}
                onChange={(e) => setNrCtr(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
                placeholder="Nr. Contract..."
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="fw-bold">Tip Contract</Form.Label>
              <Form.Select
                value={tip}
                onChange={(e) => setTip(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              >
                <option value="">Alege Tipul...</option>
                <option value="Prestari">Prestari servicii</option>
                <option value="Regie">Regie proprie</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="fw-bold">Ocol Silvic</Form.Label>
              <Form.Select
                // Blocăm selectul dacă nu este admin
                disabled={user?.rol !== "administrator"}
                // Forțăm valoarea să fie ocolul utilizatorului dacă nu e admin
                value={user?.rol === "administrator" ? ocol : user?.ocol}
                onChange={(e) => {
                  setOcol(e.target.value);
                  setPartiziSelectateIds([]);
                }}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              >
                <option value="">Alege Ocolul...</option>
                <option value="Ludus">Ludus</option>
                <option value="Targu Mures">Târgu Mureș</option>
                <option value="Reghin">Reghin</option>
                <option value="Gurghiu">Gurghiu</option>
                <option value="Fancel">Fancel</option>
                <option value="Rastolita">Rastolita</option>
                <option value="Lunca Bradului">Lunca Bradului</option>
                <option value="Sovata">Sovata</option>
                <option value="Tarnaveni">Tarnaveni</option>
                <option value="Sighisoara">Sighisoara</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={2}>
            <Form.Group>
              <Form.Label className="fw-bold">Proprietar</Form.Label>
              <Form.Select
                value={proprietar}
                onChange={(e) => setProprietar(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              >
                <option value="">Alege Proprietarul...</option>
                <option value="Stat">Stat</option>
                <option value="UAT.">U.A.T.</option>
                <option value="AD">A.D.</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-bold">Partener / Firmă</Form.Label>
              <Form.Control
                type="text"
                value={partener}
                onChange={(e) => setPartener(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
                placeholder="Nume firmă exploatare..."
              />
            </Form.Group>
          </Col>
        </Row>

        {/* SELECTARE PARTIZI CU TAG-URI */}
        <div className="mb-3">
          <Form.Label className="fw-bold text-primary">
            Partizi Disponibile:
          </Form.Label>
          {proprietar !== "Stat" ? (
            <div className="alert alert-warning">
              Contractele se opereaza doar pentru proprietatea publica a
              statului. Te rog schimba proprietarul în "Stat" pentru a adauga un
              contract.
            </div>
          ) : (
            <>
              <div className="p-3 border rounded mb-3 bg-opacity-10 bg-info">
                <Stack direction="horizontal" gap={2} className="flex-wrap">
                  {disponibile.map((p) => (
                    <Button
                      key={p.id}
                      variant={
                        tema === "dark" ? "outline-info" : "outline-primary"
                      }
                      size="sm"
                      onClick={() => adaugaPartida(p.id)}
                    >
                      <PlusCircle className="me-1" /> {p.fond} U.P. {p.up} |
                      u.a. {p.ua} | | Volum: {p.volBrut} mc ({p.valTotal} RON)
                    </Button>
                  ))}
                  {disponibile.length === 0 && (
                    <small>Nicio partidă disponibilă.</small>
                  )}
                </Stack>
              </div>
              <Form.Label className="fw-bold text-success">
                Partizi selectate pentru contract:
              </Form.Label>
              <div className="p-3 border rounded border-success ">
                <Stack direction="horizontal" gap={2} className="flex-wrap">
                  {partiziSelectateIds.map((id) => {
                    const p = partizi.find((part) => part.id === id);
                    return (
                      <Badge
                        key={id}
                        bg="success"
                        className="p-2 d-flex align-items-center"
                      >
                        {p?.fond} | {p?.valTotal} RON
                        <XCircleFill
                          className="ms-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => eliminaPartida(id)}
                        />
                      </Badge>
                    );
                  })}
                </Stack>
              </div>
            </>
          )}
        </div>

        {/* PANOU REZUMAT FINANCIAR */}
        <Row
          className="g-3 mb-4 p-3 rounded align-items-center mt-2"
          style={{
            backgroundColor: "rgba(25, 135, 84, 0.15)",
            border: "1px solid #198754",
          }}
        >
          <Col xs={6} md={6} className="text-center border-end">
            <div className="small text-muted uppercase">Volum Contract</div>
            <div className="h3 mb-0 fw-bold">
              {calcule.volum.toFixed(2)} <small>mc</small>
            </div>
          </Col>
          <Col xs={6} md={6} className="text-center">
            <div className="small text-success fw-bold">
              VALOARE TOTALĂ CONTRACT
            </div>
            <div className="h3 mb-0 text-success fw-bold">
              {calcule.valoare.toFixed(2)} <small>RON</small>
            </div>
          </Col>
        </Row>

        <Button
          variant="success"
          type="submit"
          size="lg"
          className="w-100 fw-bold shadow"
        >
          Adaugă contractul
        </Button>
      </Form>
    </Container>
  );
};

export default AdaugContract;
